import styles from './EmptyCartPage.scss';

import React, { FC } from 'react';
import { ReferencedEntry } from 'src/@types/contentful';

import { SolutionPickerModule as SolutionPickerModuleType } from 'src/api/contentful/contentTypes.cloverdotcom';
import { SolutionPickerModule } from 'src/components/SolutionPickerModule/SolutionPickerModule';
import { useContentfulEmptyCart } from './useContentfulEmptyCart';

interface SolutionsProps extends React.HTMLAttributes<HTMLDivElement> {
  entry?: ReferencedEntry<SolutionPickerModuleType>;
}

export const EmptyCartPage: FC<SolutionsProps> = ({ ...props }) => {
  const entries = useContentfulEmptyCart();
  if (!entries) return null;
  return (
    <div data-test="product-systems-catalog" className={styles.emptyCart}>
      <SolutionPickerModule {...props} entry={entries} />
    </div>
  );
};
EmptyCartPage.displayName = 'EmptyCartPage';
